//@flow
function validateRequired (value: string) {
	return value.trim().length > 0;
}

function validateEmail (value: string) {
    return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(value);
}

function validatePhone (value: string) {
    return /^[1-9]\d{6,9}$/.test(value);
}

function validateInternationalPhone (value: string) {
    return /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
}

export function validateMaxLength(max: number) {
    return (input: string) => {
        return input.length <= max;
    }
}

function validateForm (validMap: Object, state: Object, equalTo: number) {
    return new Promise((resolve, reject) => {
        let count = 0;
        Object.keys(validMap).forEach((field) => {
            const { value, ref } = state[field];
            if (ref) {
                ref.validateAndUpdate(value, true)
                .then(valid => {
                    validMap[field] = valid;
                    count++;
                    if (count === equalTo) {
                        resolve(Object.values(validMap)
                            .reduce((prev, curr) => prev && curr, true)
                        );
                    }
                })
                .catch(reject);
            } else
                reject({ message: 'Field reference not found'});
        });
    });
}

export {
	validateRequired,
	validatePhone,
	validateEmail,
    validateInternationalPhone,
	validateForm
};
